// Auto-generated skeleton for TaskType

export const TaskType: Api.TaskType = {
  id: 0,
  hp_id: null,
  name: '',
  created: null,
  updated: null,
};

